import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    selectIsAnySocketReconnecting,
    selectIsAnySocketDisconnected,
} from '../../redux/socket/socket.selectors';
import './SocketStatus.scss';

// Delay before showing the banner so transient states (intentional
// disconnect/reconnect during page navigation) don't flash to the user.
const SHOW_DELAY_MS = 1000;

const SocketStatus = () => {
    const { t } = useTranslation();
    const reconnecting = useSelector(selectIsAnySocketReconnecting);
    const disconnected = useSelector(selectIsAnySocketDisconnected);
    const unhealthy = reconnecting || disconnected;

    const [visible, setVisible] = useState(false);
    const timerRef = useRef(null);

    useEffect(() => {
        if (unhealthy) {
            timerRef.current = setTimeout(() => setVisible(true), SHOW_DELAY_MS);
        } else {
            clearTimeout(timerRef.current);
            setVisible(false);
        }
        return () => clearTimeout(timerRef.current);
    }, [unhealthy]);

    if (!visible) return null;

    const message = reconnecting
        ? t('socket_status.reconnecting')
        : t('socket_status.offline');
    const variant = reconnecting ? 'reconnecting' : 'disconnected';

    return (
        <div className={`socket-status socket-status--${variant}`} role="status" aria-live="polite">
            <span className="socket-status__dot" />
            <span className="socket-status__text">{message}</span>
        </div>
    );
};

export default SocketStatus;
